// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[master]7.3-rc-13033(cf99fbf325)-C10/07/2026-14:19:43-B10/07/2026-14:28:47' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[master]7.3-rc-13033(cf99fbf325)-C10/07/2026-14:19:43-B10/07/2026-14:28:47",
  branch: "master",
  latestTag: "7.3-rc",
  revCount: "13033",
  shortHash: "cf99fbf325",
  longHash: "cf99fbf325a96d62f740203f5ee76e5f3860add1",
  dateCommit: "10/07/2026-14:19:43",
  dateBuild: "10/07/2026-14:28:47",
  buildType: "Ansible",
  } ;
